import { useState } from 'react';
import { api } from '../lib/api.js';

/**
 * Activation du lien public.
 *
 * Le lien donne accès à l'itinéraire sans compte : on le dit clairement, et on
 * précise ce qu'il n'expose pas. Désactiver révoque définitivement le lien —
 * une réactivation en produit un nouveau, les anciens ne reviennent pas.
 */
export function PanneauPartage({ tripId, partageInitial }) {
  const [partage, setPartage] = useState(partageInitial ?? { enabled: false, url: null });
  const [erreur, setErreur] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const [copie, setCopie] = useState(false);

  async function basculer(actif) {
    setErreur(null);
    setEnvoi(true);
    try {
      const { share } = await api.post(`/trips/${tripId}/share`, { enabled: actif });
      setPartage(share);
      setCopie(false);
    } catch (echec) {
      setErreur(echec.message);
    } finally {
      setEnvoi(false);
    }
  }

  async function copier() {
    try {
      await navigator.clipboard.writeText(partage.url);
      setCopie(true);
    } catch {
      // Le presse-papiers peut être refusé : le lien reste sélectionnable.
      setErreur('Copie impossible — sélectionnez le lien pour le copier à la main.');
    }
  }

  return (
    <section className="panneau">
      <h2>Partager</h2>

      {partage.enabled ? (
        <>
          <p className="aide aide--haut">
            Toute personne disposant de ce lien peut consulter l’itinéraire, sans
            compte. La liste des voyageurs n’y figure pas — mais le programme
            lui-même peut mentionner une contrainte dont il tient compte, par
            exemple un restaurant choisi pour une allergie.
          </p>

          <p className="lien-partage">
            <input
              type="text"
              readOnly
              value={partage.url ?? ''}
              onFocus={(e) => e.target.select()}
              aria-label="Lien de partage"
            />
          </p>

          <div className="actions">
            <button className="bouton" type="button" onClick={copier}>
              {copie ? 'Lien copié' : 'Copier le lien'}
            </button>
            <button
              className="bouton bouton--discret"
              type="button"
              disabled={envoi}
              onClick={() => basculer(false)}
            >
              Désactiver le lien
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="aide aide--haut">
            Créez un lien de consultation à envoyer à vos compagnons de voyage.
            Vous pourrez le désactiver à tout moment ; le lien cesse alors
            définitivement de fonctionner.
          </p>
          <button
            className="bouton bouton--auto"
            type="button"
            disabled={envoi}
            onClick={() => basculer(true)}
          >
            {envoi ? 'Création…' : 'Créer un lien de partage'}
          </button>
        </>
      )}

      {erreur && (
        <p className="erreur" role="alert">
          {erreur}
        </p>
      )}
    </section>
  );
}
